"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactTransitionGroup = require("react-transition-group");

var _classnames = _interopRequireDefault(require("classnames"));

var _Notification = _interopRequireDefault(require("./Notification"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Notifications = /*#__PURE__*/function (_React$Component) {
  _inherits(Notifications, _React$Component);

  var _super = _createSuper(Notifications);

  function Notifications() {
    var _this;

    _classCallCheck(this, Notifications);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleRequestHide", function (notification) {
      return function () {
        var onRequestHide = _this.props.onRequestHide;

        if (onRequestHide) {
          onRequestHide(notification);
        }
      };
    });

    return _this;
  }

  _createClass(Notifications, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          notifications = _this$props.notifications,
          enterTimeout = _this$props.enterTimeout,
          leaveTimeout = _this$props.leaveTimeout;
      var className = (0, _classnames.default)('notification-container', {
        'notification-container-empty': notifications.length === 0
      });
      var items = notifications.map(function (notification) {
        var key = notification.id || new Date().getTime();
        return /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
          key: key,
          classNames: "notification",
          timeout: {
            enter: enterTimeout,
            exit: leaveTimeout
          }
        }, /*#__PURE__*/_react.default.createElement(_Notification.default, {
          type: notification.type,
          title: notification.title,
          message: notification.message,
          timeOut: notification.timeOut,
          onClick: notification.onClick,
          onRequestHide: _this2.handleRequestHide(notification)
        }));
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: className
      }, /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.TransitionGroup, null, items));
    }
  }]);

  return Notifications;
}(_react.default.Component);

_defineProperty(Notifications, "propTypes", {
  notifications: _propTypes.default.array,
  onRequestHide: _propTypes.default.func,
  enterTimeout: _propTypes.default.number,
  leaveTimeout: _propTypes.default.number
});

_defineProperty(Notifications, "defaultProps", {
  notifications: [],
  onRequestHide: function onRequestHide() {},
  enterTimeout: 400,
  leaveTimeout: 400
});

var _default = Notifications;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-notifications/lib/Notifications.js
// module id = 630
// module chunks = 0